export default __webpack_public_path__ + "f2f8f7d204c8fa68690567ac3ff58be8.png";